import { VisualizationTable } from '../use-visualization-store/useVisualizationStore';
import { generateImageTag } from './generateImageTag';
import { generateTableTag } from './generateTableTag';
import { htmlNodes } from './htmlNodes';
import { patterns } from './regex';

const getVisualizationIds = (text: string) => {
  return Array.from(text.matchAll(patterns.linkWithTitle), match => match[2]);
};

interface ReplaceVisualizationLinksArgs {
  originalContent: string;
  charts: Record<string, HTMLDivElement>;
  tables: Record<string, VisualizationTable>;
}

export const replaceVisualizationLinks = ({
  originalContent,
  charts,
  tables,
}: ReplaceVisualizationLinksArgs) => {
  let result = originalContent;

  const visualizationIds = getVisualizationIds(originalContent);

  if (visualizationIds.length) {
    visualizationIds.forEach(id => {
      // find the link, e.g. [xxxx](id "apache-line")
      const dynamicPattern = patterns.linkWithId(id);

      if (charts[id]) {
        const imgTag = generateImageTag(charts[id]);
        result = result.replace(
          dynamicPattern,
          (_m, title) => `${htmlNodes.span(title)}${imgTag}`
        );
      }

      if (tables[id]) {
        const tableData = generateTableTag(tables[id]);
        result = result.replace(
          dynamicPattern,
          (_m, title) => `${htmlNodes.span(title)}${tableData}`
        );
      }
    });
  }

  return result;
};
